import { storeRegion } from '../../../utils';
import axios from 'axios';

export const useCompleteCartPaypal = async (
  cartClientId: string | undefined
) => {
  const externalGateway =
    process?.env?.NEXT_PUBLIC_EXTERNAL_SERVICE_URL || 'http://localhost:4846';
  let error = null;
  let dataResponse = null;
  const region = storeRegion();

  try {
    const response = await axios.post(
      externalGateway + '/v1/paypal/complete/cart',
      {
        cartClientId: cartClientId,
      },
      {
        headers: {
          'x-waldo-region': region,
        },
      }
    );

    dataResponse = response.data;
  } catch (errorResponse) {
    error = errorResponse;
  }

  return { dataResponse, error };
};
